export interface IOptnRegion {
    id: number,
    regionNumber: number,
    states: string
}